import formatGmaddressFields from 'utils/format-gmaddress-fields.js';

/**
 * @name ShopProfileController
 * @description Controller called to displa and manage appointment details.
 * @param {Unknown} Shop Shop service
 * @param {Unknown} ScheduleUtilFactory Schedule service
 * @param {Unknown} Session Session service
 * @param {Unknown} CheckUsername CheckUsername service
 * @param {Unknown} AlertMessages AlertMessages service
 * @param {Unknown} GMAPS_KEY Google maps key constant
 * @param {Unknown} $log Angular log service
 * @param {Unknown} NgMap NgMap library
 * @param {service} Upload The Upload service from the ng-file-upload library
 * @param {string} ENDPOINT The endpoint constant
 * @param {service} InkImage The image servce
 * @param {service} $cookies Angular cookies service
  @param {library} _ The Lodash library
 */
function ShopProfileController(
  Shop,
  ScheduleUtilFactory,
  Session,
  CheckUsername,
  AlertMessages,
  GMAPS_KEY,
  $log,
  NgMap,
  Upload,
  ENDPOINT,
  InkImage,
  $cookies,
  _
) {
  let vm = this;

  vm.$onInit = function() {
    vm.googleMapsUrl =
      'https://maps.googleapis.com/maps/api/js?&libraries=places&key=' +
      GMAPS_KEY;
    vm.placeChanged = placeChanged;
    vm.checkUsername = checkUsername;
    vm.updateShop = updateShop;
    vm.updateProfileLogo = updateProfileLogo;
    vm.uploadFullLogo = uploadFullLogo;
    vm.remove = remove;
  };

  // Get the shop of the logged in operator
  const shop = Session.activeState.association.shop;

  // Get the shop profile
  Shop.get(shop.id).then(function(shop) {
    vm.shop = shop;
    vm.gmaddressTmp = vm.shop.gmaddress;
    vm.currentShopUsername = _.cloneDeep(shop.username);
    if (vm.shop.full_logo) {
      InkImage.get(vm.shop.full_logo).then(function(fullLogo) {
        vm.fullLogo = fullLogo;
      });
    }
    NgMap.getMap().then(function(map) {
      vm.map = map;
      vm.map.setCenter({
        lat: Number(vm.shop.lat),
        lng: Number(vm.shop.lng)
      });
    });
  });

  /**
   * @name placeChanged
   * @description Google maps autocomplete
   */
  function placeChanged() {
    vm.place = this.getPlace(); // Use of 'this' is based on the library
    formatGmaddressFields(vm.place.address_components).then(addressFields => {
      Object.assign(vm.shop, addressFields);
    });

    vm.shop.gmaddress = vm.place.formatted_address;
    vm.gmaddressTmp = vm.place.formatted_address;
    vm.shop.lat = vm.place.geometry.location.lat();
    vm.shop.lng = vm.place.geometry.location.lng();
    vm.shop.gmaddress_url = vm.place.url;
    vm.map.setCenter(vm.place.geometry.location);
  }

  /**
   * @name checkUsername
   * @description Function to check it a username exists when setting one
   * @param {string} username The username to check
   */
  function checkUsername(username) {
    CheckUsername.check(username, vm.currentShopUsername).then(function(
      results
    ) {
      vm.usernameResults = results;
    });
  }

  /**
   * @name update_shop
   * @description Function to call the shop service to update the shop
   * @param {object} shop The shop to update
   */
  function updateShop(shop) {
    Shop.update(shop).then(function(updatedShop) {
      vm.shop = updatedShop;
    });
  }

  /**
   * @name updateProfileLogo
   * @description Function to update the shop profile logo
   * @param {number} imageId The ID of the new profile logo
   */
  function updateProfileLogo(imageId) {
    vm.shop.profile_logo = imageId;
    Shop.update(vm.shop).then(function(updatedShop) {
      vm.shop = updatedShop;
      let updateAssociationShop = {
        id: updatedShop.id,
        name: updatedShop.name,
        profile_logo: updatedShop.profile_logo
      };
      Session.activeState.association.shop = updateAssociationShop;
      $cookies.putObject('inkfinder', Session.activeState);
    });
  }

  /**
   * @name updateFullLogo
   * @description Function to update the shop full logo
   * @param {number} imageId The ID of the new full logo
   */
  function updateFullLogo(imageId) {
    vm.shop.full_logo = imageId;
    Shop.update(vm.shop).then(function(updatedShop) {
      vm.shop = updatedShop;
      if (vm.shop.full_logo) {
        InkImage.get(vm.shop.full_logo).then(function(fullLogo) {
          vm.fullLogo = fullLogo;
        });
      }
    });
  }

  /**
   * @name uploadFullLogo
   * @description Function to upload the shop full logo
   * @param {file} file The file to upload
   * @param {array} errFiles Errors array
   */
  function uploadFullLogo(file, errFiles) {
    vm.f = file;
    vm.errFile = errFiles && errFiles[0];
    if (file) {
      file.upload = Upload.upload({
        url: ENDPOINT.server + 'inkutils/api/v1.1/image/',
        data: {file: file}
      });
      file.upload.then(
        function(response) {
          file.result = response.data;
          updateFullLogo(file.result.id);
        },
        function(response) {
          if (response.status > 0) {
            vm.errorMsg = response.status + ': ' + response.data;
          }
        },
        function(evt) {
          file.progress = Math.min(
            100,
            parseInt(100.0 * evt.loaded / evt.total, 10)
          );
        }
      );
    }
  }

  /**
   * @name remove
   * @description Function to remove the profile image
   * @param {number} imageId The image to remove
   */
  function remove(imageId) {
    let file = '';
    InkImage.remove(imageId, file).then(function(image) {
      vm.fullLogo.image = null;
      vm.shop.full_logo = '';
      updateFullLogo(vm.shop.full_logo);
    });
  }
}

angular
  .module('inkfinder')
  .controller('ShopProfileController', ShopProfileController);



// WEBPACK FOOTER //
// ./components/shop/profile/shop-profile.controller.js